
window.jQuery = jQuery;
window.$ = jQuery;

// vendor
require('./vendor/modernizr/modernizr-custom.js');

// Sequence depending
require('../library/legacy/setviewport.js');
require('../library/legacy/mobile_detect_device.js');
require('../library/legacy/popup-externe-url.js');

// Sequence indifferent
require('../library/legacy/a11y.js');
require('../library/legacy/anchor.js');
require('../library/legacy/boxtip.js');
require('../library/legacy/bigbuttons.js');
require('../library/legacy/fixed-footer.js');
require('../library/legacy/class_toggles.js');
require('../library/legacy/details-toggle.js');
require('../library/legacy/faqlist.js');
require('../library/legacy/focustrap.js');
require('../library/legacy/fonts.js');
require('../library/legacy/harmonica.js');
require('../library/legacy/helper.js');
require('../library/legacy/init.js');
require('../library/legacy/klantquotes.js');
require('../library/legacy/setmeetids');
require('../library/legacy/personalization.js');
require('../library/legacy/searchbox.js');
require('../library/legacy/sitelint.js');
require('../library/legacy/tooltip.js');
require('../library/legacy/cookie_checks.js');
require('../library/legacy/a-content-block.js');
require('../library/legacy/toggle.js');
require('../library/observer.js');

// Sequence depending - last
require('../library/legacy/finalize.js');
